/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {RegisterLiteP2pPaymentRequest} from '@cash-web/protos/squareup/cash/cashliteorchestrator/api/v1beta1/orchestrator.pb'
import {RegisterLiteP2pPaymentResponse} from '@cash-web/protos/squareup/cash/cashliteorchestrator/api/v1beta1/orchestrator.pb'


export const registerLiteP2pPayment = (request: RegisterLiteP2pPaymentRequest, options?: CashRequestOptions) => post<RegisterLiteP2pPaymentRequest, RegisterLiteP2pPaymentResponse>("/2.0/cash/register-lite-p2p-payment", request, {...options, rejectOnError: true })